const input = {
    username: 'Имя пользователя',
    password: 'Пароль',
    email: 'Электронная почта',
    phone_number: 'Номер телефона',
    confirm_password: 'Подтверждение пароля',
    search_region_code: 'Поиск кода региона',
    backup_code: 'Резервный код',
    code: 'Код',
    label_with_optional: '{{label}} (Необязательно)',
    email_address: 'Адрес электронной почты',
    email_placeholder: 'Введите электронную почту',
    enter_email: 'Введите электронную почту',
};
export default Object.freeze(input);
